import request from "@/utils/request";

export function login (data) {
    return request({
        url: "/user_dept/login",
        method: "post",
        // params: data
        data
    });
}



